import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';

// Card de relatório: ícone, título, descrição, opções e botão de gerar.
const RelatorioCard = ({ icon, titulo, descricao, formato, onGerar, desabilitado, children }) => {
  const [loading, setLoading] = useState(false);

  const gerar = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onGerar();
    } finally {
      setLoading(false);
    }
  };

  return (
    <article className="va-rel-card">
      <header className="va-rel-topo">
        <span className="va-rel-icone"><Icon name={icon} /></span>
        <div className="va-rel-titulo">
          <h3>{titulo}</h3>
          <span className={`va-rel-formato ${formato === 'Word' ? 'word' : 'pdf'}`}>{formato}</span>
        </div>
      </header>
      <p className="va-rel-descricao">{descricao}</p>
      {children && <div className="va-rel-opcoes">{children}</div>}
      <Button className="btn-ui-1 va-rel-gerar" loading={loading} disabled={loading || desabilitado} onClick={gerar}>
        <Icon name="download" /> {loading ? 'Gerando...' : `Gerar ${formato}`}
      </Button>
    </article>
  );
};

RelatorioCard.propTypes = {
  icon: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  descricao: PropTypes.string,
  formato: PropTypes.string,
  onGerar: PropTypes.func.isRequired,
  desabilitado: PropTypes.bool,
  children: PropTypes.node
};

RelatorioCard.defaultProps = { formato: 'PDF' };

export default RelatorioCard;
